import { useState } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";
import { updateProfile } from "../../../../api/UserAPI";
import { Switch, Tooltip } from "@mantine/core";
import { useProfileStore } from "../../../../stores/UserStore";
import { useParams } from "react-router-dom";

const LeadAnswerNegativeNotif = () => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(false);
  const profile = useProfileStore((s) => s.profile);
  const { userId } = useParams();

  const [checked, setChecked] = useState(profile?.send_negative_reply_mail);

  const onChange = () => {
    let newValue = !checked;
    setChecked(newValue);
    setLoading(true);
    updateProfile(null, { send_negative_reply_mail: newValue })
      .then(() => {
        useProfileStore.getState().setProfile({
          ...useProfileStore.getState().profile,
          send_negative_reply_mail: newValue,
        });
      })
      .catch(() => {
        setChecked(!newValue);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Tooltip
      label={
        lang.administration.right.rights.list.send_negative_reply_mail_tooltip
      }
    >
      <Switch
        disabled={userId ? profile.id !== parseInt(userId) : loading}
        onChange={onChange}
        checked={checked}
        color="red"
        size="md"
        label={lang.table.toolbar.filter.filters_list_label.server.negative}
        tt={"capitalize"}
      />
    </Tooltip>
  );
};

export default LeadAnswerNegativeNotif;
